import { store } from '../store'
import DynamicModuleRegistrationUtil from '../utils/dynamicModuleRegistration'
import { ProductsEnum } from '../enums/modules/routes'
import ImportProductsRoutes from './importProducts'
import Router from '../router'
import ShipbobAppSettings from '@/appSettings/appSetting'
import { productDetailBeforeEnter } from './guards/productDetailGuards'

export const V2_PRODUCTS_ROUTE = ShipbobAppSettings.productV2Route

const ProductsStoreModule = () =>
  import(/* webpackChunkName: "Products" */ '../store/modules/products')

const ProductsPlaceholder = () =>
  import(/* webpackChunkName: "Products" */ '@/components/products/ProductsPlaceholder')

const Products = () =>
  import(/* webpackChunkName: "Products" */ '@/components/products/Products')

const ProductDetailsPlaceholder = () =>
  import(/* webpackChunkName: "Products" */ '@/components/products/ProductDetailsPlaceholder')

const ProductDetails = () =>
  import(/* webpackChunkName: "Products" */ '@/components/products/ProductDetails')

const MergeProductsWrapper = () =>
  import(/* webpackChunkName: "Products" */ '@/components/products/mergeProducts/MergeProductsWrapper')

const ConfirmUnmerge = () =>
  import(/* webpackChunkName: "Products" */ '@/components/products/ConfirmUnmerge')

const CreateAddToBundle = () =>
  import(/* webpackChunkName: "Products" */ '@/components/products/bundle/CreateAddToBundle')

const Unbundle = () =>
  import(/* webpackChunkName: "Products" */ '@/components/products/bundle/Unbundle')

const RemoveFromBundle = () =>
  import(/* webpackChunkName: "Products" */ '@/components/products/bundle/RemoveFromBundle')

const dynamicModuleRegistrationProductsArgs = () => {
  return {
    modulesNamespace: store._modulesNamespaceMap,
    moduleName: 'products',
    module: ProductsStoreModule,
    store,
    modulePath: 'products'
  }
}

const mapMergedChildrenQueryString = (children) =>
  children && children.split(',').map(id => parseInt(id)).filter(id => !isNaN(id))

const productRoutes = [
  {
    path: '/products-beta',
    component: Products,
    beforeEnter (_to, _from, next) {
      DynamicModuleRegistrationUtil(dynamicModuleRegistrationProductsArgs()).then(
        () => next()
      )
    },
    meta: { domain: ProductsEnum.Products, showSideNav: true }
  },
  {
    path: '/Products',
    component: ProductsPlaceholder,
    beforeEnter (_to, _from, next) {
      DynamicModuleRegistrationUtil(dynamicModuleRegistrationProductsArgs()).then(
        () => next()
      )
    },
    // domain used for breadcrumbs
    meta: { domain: ProductsEnum.Products },
    children: [
      {
        path: 'MergeProducts',
        name: ProductsEnum.MergeProducts,
        component: MergeProductsWrapper,
        props: (route) => ({
          preferredParent: parseInt(route.query.preferredParent) || parseInt(route.query.parent) || null,
          children: mapMergedChildrenQueryString(route.query.children),
          child: parseInt(route.query.child) || null
        })
      },
      {
        path: 'Unmerge',
        name: ProductsEnum.UnmergeProduct,
        component: ConfirmUnmerge,
        props: (route) => ({
          rootId: route.params.rootId,
          childId: route.params.childId
        })
      },
      {
        path: ':productId',
        component: ProductDetailsPlaceholder,
        // eslint-disable-next-line dot-notation
        beforeEnter: (to, _from, next) => productDetailBeforeEnter(to, next, store.getters['enableNewProductCatalog']),
        children: [
          {
            path: 'CreateBundle',
            name: ProductsEnum.CreateBundle,
            meta: { showSideNav: false },
            component: CreateAddToBundle,
            props: (route) => ({
              rootId: parseInt(route.params.productId),
              product: route.params.product
            })
          },
          {
            path: 'Unbundle',
            name: ProductsEnum.Unbundle,
            component: Unbundle,
            props: (route) => ({
              parentId: parseInt(route.params.productId),
              parentName: route.params.parentName
            }),
            beforeEnter (to, from, next) {
              if (!to.params.parentName) {
                Router.push({ name: ProductsEnum.ProductDetails, params: { productId: to.params.productId } })
              } else {
                next()
              }
            }
          },
          {
            path: 'AddToBundle',
            name: ProductsEnum.AddToBundle,
            meta: { showSideNav: false },
            component: CreateAddToBundle,
            props: (route) => ({
              rootId: parseInt(route.params.productId),
              product: route.params.product
            })
          },
          {
            path: 'RemoveFromBundle',
            name: ProductsEnum.RemoveFromBundle,
            component: RemoveFromBundle,
            props: (route) => ({
              parentId: parseInt(route.params.productId),
              childId: route.params.childId,
              parentName: route.params.parentName,
              childName: route.params.childName
            }),
            beforeEnter (to, from, next) {
              if (!to.params.childId) {
                Router.push({ name: ProductsEnum.ProductDetails, params: { productId: to.params.productId } })
              } else {
                next()
              }
            }
          },
          {
            path: '/',
            component: ProductDetails,
            name: ProductsEnum.ProductDetails,
            meta: { showSideNav: true },
            props: (route) => ({
              productId: parseInt(route.params.productId),
              editable: false
            })
          }
        ]
      },
      {
        path: '/',
        // component: Products,
        name: ProductsEnum.Products,
        meta: { showSideNav: true },
        beforeEnter (to, from, next) {
          window.location.replace(V2_PRODUCTS_ROUTE)
        }
      }
    ]
  }
]

export default ImportProductsRoutes.concat(productRoutes)
